import PlatformDetector from "./PlatformDetector";

export const MISBookingMode = () =>{

if (PlatformDetector.isDesktop()) 
{
               
	return { deviceType: 21, MISBookingMode: 1 }; // desktop mode

}

else if (PlatformDetector.isMobile) 
{
	if (PlatformDetector.isAndroidWebView()) 
	{

		return {
			deviceType: 31, // android webview
			MISBookingMode: 2 // mobile android webview mode
		};
	  
	} 
	else if (PlatformDetector.isIOSWebView()) 
	{
		return {
			deviceType: 41, // ios webview
			MISBookingMode: 3 // mobile ios webview mode
		};
	 
	} 
	else 
	{
	  if (PlatformDetector.isAndroid()) 
	  {

		return{
			deviceType: 22, // android browser
			MISBookingMode: 1 // mobile android webview mode
		};

	 
	  } 
	  else if (PlatformDetector.isIOS()) 
	  {

		return {
			deviceType: 22, // ios browser
			MISBookingMode: 1 // mobile ios webview mode
		};

	   
	  } 
	  else 
	  {
			return {
				deviceType: 23, // other mobile browser
				MISBookingMode: 1 // mobile ios webview mode// other mobile browser
			};
	  
	  }
	}
} 
else if (PlatformDetector.isTablet()) 
{
	if (PlatformDetector.isAndroidWebView()) 
	{
		return{
			deviceType: 32, 
			MISBookingMode: 2 
		};
	  
	} 
	else if (PlatformDetector.isIOSWebView()) 
	{
			return {
				deviceType: 42,
				MISBookingMode: 3
			};
	  
	} 
	else 
	{
	  if (PlatformDetector.isAndroid()) 
	  {
		return{
			deviceType: 23, // android browser
			MISBookingMode: 1 // android browser
		};
	
	  } 
	  else if (PlatformDetector.isIOS()) 
	  {

		return {
			deviceType: 23, // ios browser
			MISBookingMode: 1 // ios browser
		};
	  
	  } 
	  else {

		return {deviceType:23, MISBookingMode:1};
		
	   
	  }
	}
  } 
  else 
  {
	return {
		deviceType: 23, // unknown
		MISBookingMode: 1
	};
  }
                
             

} 